import { render, staticRenderFns } from "./CurriculumSyllabusEECTable.vue?vue&type=template&id=6c446dc8&scoped=true&"
import script from "./CurriculumSyllabusEECTable.vue?vue&type=script&lang=ts&"
export * from "./CurriculumSyllabusEECTable.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumSyllabusEECTable.vue?vue&type=style&index=0&id=6c446dc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c446dc8",
  null
  
)

export default component.exports